<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Pengaturan</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Pengaturan PIN</div>
					</div>
				</div>
			</div>
			<div class="col-12 pl-0 pr-0 py-4">
				<div class="col-6 pl-0 pr-0 pb-2 rounded-cus bg-white overflow-hidden">
                    <div class="col-12 pt-3 font-size-10">
                        PIN digunakan untuk login dan transaksi
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="PIN" v-model="pin_code" :maxlength="pin_max_length" :minlength="pin_min_length">
                        <div class="font-size-8 pt-1">PIN terdiri dari 6 digit angka. [{{ pin_code.length}} / {{ pin_max_length }}]</div>
                        <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.pin_code">{{ konfirmResponse.pin_code }} </div>
                    </div>
					<div class="col-12 pt-3 pb-2 d-flex justify-content-md-end">
						<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="simpanPin">
							<div class="font-size-11 text-uppercase">simpan</div>
						</button>
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3" v-if="pin_success == false">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 pt-3 font-size-10 text-center">
                            Silahkan memasukkan kode OTP yang telah dikirim ke nomor handphone Anda
                        </div>
						<div class="col-12 pt-3">
                            <input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Kode OTP" v-model="otp_code">
                            <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.msg">{{ konfirmResponse.msg }} </div>
                        </div>
					</div>
				</div>
                <div class="modal-body pt-0 pt-md-3" v-else>
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 font-size-10 text-center">
                            PIN berhasil disimpan
                        </div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-center" v-if="pin_success == false">
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalAlert">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="submitPin">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Ok</div>
						</button>
					</div>
                    <div class="modal-footer justify-content-center justify-content-center" v-else>
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalAlertSuccess">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Tutup</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import IModal from '@/components/IModal.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
	components: {
		IModal
	},
	data() {
		return {
			pin_code: '',
            pin_max_length: 6,
            pin_min_length: 6,
			otp_code: '',
            pin_success: false,
            modal_show: false
		}
	},
	computed: {
		...mapState('auth', ['userData', 'is_have_pin']),
		...mapState('profileList', ['responSukses', 'konfirmResponse']),
	},
	methods: {
		...mapMutations('profileList', ['saveConfirmResponse']),
		...mapActions('profileList', ['requestOtpCode', 'setPin']),
		...mapMutations('profileList', ['konfirmasiSukses']),

		simpanPin() {
            if (this.pin_code.length == this.pin_min_length && this.pin_code.length == this.pin_max_length) {
                var params = {
                    pin_code: this.pin_code
                }

                //console.log('Pin.vue', this.is_have_pin)

                if (this.is_have_pin == true) {
                    this.requestOtpCode(params).then(() => {
                        if (this.responSukses == 200) {
                            this.otp_code = ''
                            this.$refs.modalAlert.modalShow()
                            this.modal_show = true
                        }
                    })
                } else {
                    this.otp_code = '000000'
                    this.submitPin()
                }
            }
		},
        batal() {
		},
        hideModalAlert() {
            this.$refs.modalAlert.modalHide()
            this.modal_show = false
        },
        hideModalAlertSuccess() {
            this.$router.go()
        },
        submitPin(){
            if (this.pin_code.length > 0 && this.otp_code.length > 0) {
                var params = {
                    pin_code: this.pin_code,
                    otp_code: this.otp_code
                }

                this.setPin(params).then(() => {
                    //console.log(this.responSukses)
                    if (this.responSukses == 200) {
                        this.pin_code = ''
                        this.pin_success = true
                        
                        if (this.modal_show == false) {
                            this.$refs.modalAlert.modalShow()
                        }
                    }
                })
            }
        }
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Pengaturan PIN');
	}
};
</script>
